import React, { Component } from 'react';
import i18n from '../i18n';
import { status as statusConfig, customerProfiles, availableSettings } from '../config/AppConfig';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/styles';
import withWidth from '@material-ui/core/withWidth';
import { withTranslation } from 'react-i18next';
import Global from '../lib/Global';
import PersonsActions from '../redux/PersonsRedux';
import AccessLevelsActions from '../redux/AccessLevelsRedux';
import TagsActions from '../redux/TagsRedux';
import TagTypesActions from '../redux/TagTypesRedux';
import Header from '../components/header/Header';
import { Colors, StyledComponents, Metrics } from '../themes';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Table from '../components/common/Table';
import PersonDetails from '../components/personsElements/PersonDetails';
import clsx from 'clsx';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash.isequal';
import AlertDialog from '../components/common/AlertDialog';
import SnackbarNotification from '../components/common/SnackbarNotification';
import Modal from '../components/common/Modal';
import TagEditModal from '../components/personsElements/TagEditModal';
import AccessLevelsModal from '../components/personsElements/AccessLevelsModal';
import {
  hackToAddOffset,
  displayAbsoluteTime,
  convertUnicode,
  isTagValid,
  checkPermission,
  validateField,
} from '../lib/Utils';
import { addHours } from 'date-fns';

const { MainContentContainer } = StyledComponents;

const styles = (theme) => ({
  gridContainer: {
    [theme.breakpoints.up('xl')]: {
      maxWidth: Metrics.contentGridMaxWidthXl.general,
    },
  },
  paper: {
    textAlign: 'center',
    background: Colors.hoverGrey,
    color: Colors.white,
  },
  listWidget: {},
  detailsWidget: {
    maxWidth: 975,
  },
});

class Persons extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // snackbar
      isSnackbarNotificationOpen: false,
      snackbarVariant: 'warning',
      snackbarMessage: '',
      // alert confirm dialog
      isAlertDialogOpen: false,
      alertTitle: '',
      alertContentText: '',
      alertConfirmAction: null,
      alertConfirmButtonString: 'Global_delete',
      //persons page params
      personsItemsPerPage: 10,
      personsPageNumber: 0,
      personsSearchValue: null,
      personsSortBy: 'lastName',
      personsSortDirection: 'ASC',
      // person details
      hideDetails: true,
      isNewPerson: false,
      personId: null,
      addressId: null,
      firstName: '',
      lastName: '',
      personNumber: '',
      company: '',
      phone: '',
      email: '',
      externalId: '',
      readOnly: false,
      // tags table
      tagsItemsPerPage: 10,
      tagsPageNumber: 0,
      tagsSearchValue: null,
      tagsSortBy: 'tagUid',
      tagsSortDirection: 'ASC',
      isEditTagModalOpen: false,
      // tags details form
      isNewTag: false,
      tagId: null,
      tagUid: null,
      status: 1,
      tagPin: '',
      tagTypeId: '',
      accessLeft: '',
      minTime: null,
      maxTime: null,
      activateDelay: null,
      requirePinCode: null,
      mobileId: false,
      // access levels
      accesslevels: [],
      checkedAccessLevels: [],
      isAccessLevelsModalOpen: false,
      accesslevelsItemsPerPage: 10,
      accesslevelsPageNumber: 0,
      accesslevelsSearchValue: null,
      // validation
      isUntouched: true,
      // HID in tag creation
      isHIDSupported: false,
      useHID: false,
      showHIDEmailValidationError: false,
      hasHIDTag: false,
    };
  }

  componentDidMount() {
    if (Global.api.accessToken && this.props.customerId) {
      this.sendGetPersonsRequest();
      this.checkHID();
    }
  }

  componentWillUnmount() {
    this.props.resetPersons();
    this.props.resetTags();
    this.props.resetTagTypes();
    this.props.resetAccessLevels();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.customerId !== this.props.customerId) {
      this.props.resetPersons();
      this.props.resetTags();
      this.props.resetTagTypes();
      this.props.resetAccessLevels();
      this.resetPersonFormFields();
      this.resetTagFormFields();
      if (this.props.customerId) {
        this.sendGetPersonsRequest();
        this.checkHID();
      }
    }
    if (prevProps.personsIsLoading && !this.props.personsIsLoading) {
      if (this.props.personsSuccessMessage) {
        this.setState({
          isSnackbarNotificationOpen: true,
          snackbarVariant: 'success',
          snackbarMessage: this.props.personsSuccessMessage,
        });
      }
      if (this.props.personsErrorMessage) {
        this.setState({
          isSnackbarNotificationOpen: true,
          snackbarVariant: 'error',
          snackbarMessage: this.props.personsErrorMessage,
        });
      }
      if (prevProps.createdId !== this.props.createdId) {
        this.setState({
          personId: this.props.createdId,
          addressId: this.props.createdAddressId,
          isNewPerson: false,
        });
      }
    }
    if (prevProps.tagsIsLoading && !this.props.tagsIsLoading) {
      if (this.props.tagsSuccessMessage) {
        this.setState({
          isSnackbarNotificationOpen: true,
          snackbarVariant: 'success',
          snackbarMessage: this.props.tagsSuccessMessage,
        });
      }
      if (this.props.tagsErrorMessage) {
        this.setState({
          isSnackbarNotificationOpen: true,
          snackbarVariant: 'error',
          snackbarMessage: this.props.tagsErrorMessage,
        });
      }
    }
    // HID show email validation error
    if (
      prevState.isHIDSupported !== this.state.isHIDSupported ||
      prevState.useHID !== this.state.useHID ||
      prevState.personId !== this.state.personId ||
      prevProps.savedEmail !== this.props.savedEmail ||
      prevState.isEditTagModalOpen !== this.state.isEditTagModalOpen
    ) {
      const selectedPerson = this.props.persons?.find((person) => person.personId === this.state.personId);
      const savedEmail = selectedPerson ? selectedPerson?.address?.email : this.props.savedEmail;
      const isEmailValid = !!savedEmail && validateField('email', savedEmail);
      this.setState({ showHIDEmailValidationError: this.state.isHIDSupported && this.state.useHID && !isEmailValid });
    }
    // if tags are updated, check if any are HID to disable the email
    if (!isEqual(prevProps.tags, this.props.tags)) {
      const hasHIDTag = this.props.tags.some((tag) => tag.mobileId);
      this.setState({ hasHIDTag });
    }
  }

  //common methods

  handleChangeFormValues = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  // persons list table methods

  sendGetPersonsRequest() {
    const pageParams = {
      items: this.state.personsItemsPerPage,
      page: this.state.personsPageNumber,
      ...(this.state.personsSearchValue && { value: this.state.personsSearchValue }),
      sortBy: `address.${this.state.personsSortBy}`,
      sortDirection: this.state.personsSortDirection,
    };
    this.props.getPersons(this.props.customerId, pageParams);
  }

  changePersonsItemsPerPage = (personsItemsPerPage) => {
    this.setState({ personsItemsPerPage, personsPageNumber: 0 }, () => this.sendGetPersonsRequest());
  };

  changePersonsPage = (personsPageNumber) => {
    this.setState({ personsPageNumber }, () => this.sendGetPersonsRequest());
  };

  handleSearchPerson = (personsSearchValue) => {
    this.setState({ personsSearchValue, personsPageNumber: 0 }, () => this.sendGetPersonsRequest());
    this.resetPersonFormFields();
  };

  handleSortPerson = (personsSortBy, personsSortDirection) => {
    this.setState({ personsSortBy, personsSortDirection, personsPageNumber: 0 }, () => this.sendGetPersonsRequest());
    this.resetPersonFormFields();
  };

  handleSearchPersonKeyPress = (event, value) => {
    if (event.key === 'Enter') {
      this.handleSearchPerson(value);
    }
  };

  selectPerson = (selectedPerson) => {
    this.resetPersonFormFields();
    let personId = selectedPerson.personId ? selectedPerson.personId : null,
      addressId = selectedPerson.address && selectedPerson.address.addressId ? selectedPerson.address.addressId : null,
      firstName =
        selectedPerson.address && selectedPerson.address.firstName
          ? convertUnicode(selectedPerson.address.firstName)
          : '',
      lastName =
        selectedPerson.address && selectedPerson.address.lastName
          ? convertUnicode(selectedPerson.address.lastName)
          : '',
      phone = selectedPerson.address && selectedPerson.address.phone ? selectedPerson.address.phone : '',
      email = selectedPerson.address && selectedPerson.address.email ? selectedPerson.address.email : '',
      personNumber = selectedPerson.personNumber ? selectedPerson.personNumber : '',
      externalId = selectedPerson?.externalId || '',
      readOnly = selectedPerson.readOnly,
      company = selectedPerson.personCompanyInfo ? convertUnicode(selectedPerson.personCompanyInfo) : '';
    this.setState(
      {
        hideDetails: false,
        isNewPerson: false,
        personId,
        addressId,
        firstName,
        lastName,
        personNumber,
        company,
        phone,
        email,
        externalId,
        useHID: false,
        readOnly,
        isUntouched: true,
      },
      () => this.sendGetTagsRequest(),
    );
  };

  // Person details form methods

  resetPersonFormFields = () => {
    this.setState({
      personId: null,
      addressId: null,
      firstName: '',
      lastName: '',
      personNumber: '',
      company: '',
      phone: '',
      email: '',
      readOnly: false,
      externalId: '',
    });
    this.props.resetTags();
  };

  handleAddPerson = () => {
    this.resetPersonFormFields();
    this.setState({ hideDetails: false, personsSearchValue: null, isNewPerson: true, isUntouched: true });
  };

  handleSavePerson = () => {
    const { personId, addressId, firstName, lastName, personNumber, company, phone, email } = this.state;
    const personInfos = {
      address: { firstName, lastName, phone, email },
      personNumber,
      personCompanyInfo: company,
      customerId: this.props.customerId,
      statusId: 1,
    };
    const editPersonInfos = { ...personInfos, personId, address: { ...personInfos.address, addressId } };
    const pageParams = {
      items: this.state.personsItemsPerPage,
      page: this.state.personsPageNumber,
      value: this.state.personsSearchValue,
      sortBy: `address.${this.state.personsSortBy}`,
      sortDirection: this.state.personsSortDirection,
    };
    this.state.isNewPerson
      ? this.props.createPerson([personInfos], this.props.customerId, pageParams)
      : this.props.editPerson(editPersonInfos);
  };

  openDeletePersonAlert = () => {
    const personName = this.state.firstName
      ? `${this.state.firstName}${this.state.lastName ? ' ' + this.state.lastName : null}`
      : this.state.lastName;
    this.setState({
      isAlertDialogOpen: true,
      alertTitle: i18n.t('alert.deletePersonTitle'),
      alertContentText: i18n.t('personManager_confirmDeletePerson', { personName }),
      alertConfirmAction: this.deletePerson,
      alertConfirmButtonString: 'Global_delete',
    });
  };

  deletePerson = () => {
    const pageParams = {
      items: this.state.personsItemsPerPage,
      page: this.state.personsPageNumber,
      value: this.state.personsSearchValue,
      sortBy: `address.${this.state.personsSortBy}`,
      sortDirection: this.state.personsSortDirection,
    };
    this.props.deletePerson(this.state.personId, this.props.customerId, pageParams);
    this.resetPersonFormFields();
    this.setState({ isAlertDialogOpen: false, hideDetails: true });
  };

  handlePersonDetailsFormKeyPress = (event) => {
    if (event.key === 'Enter') {
      if (!this.state.personsSearchValue) {
        return this.handleSavePerson();
      }
    }
  };

  // Tags methods in detailsWidget

  sendGetTagsRequest() {
    let sortBy;
    switch (this.state.tagsSortBy) {
      case 'statusDisplay':
        sortBy = 'status';
        break;
      case 'accessLevelNames':
        sortBy = null;
        break;
      default:
        sortBy = this.state.tagsSortBy;
    }
    const pageParams = {
      items: this.state.tagsItemsPerPage,
      page: this.state.tagsPageNumber,
      value: this.state.tagsSearchValue,
      sortBy,
      sortDirection: this.state.tagsSortDirection,
    };
    this.props.getTags(this.state.personId, this.props.customerId, pageParams);
  }

  changeTagsItemsPerPage = (tagsItemsPerPage) => {
    this.setState({ tagsItemsPerPage, tagsPageNumber: 0 }, () => this.sendGetTagsRequest());
  };

  changeTagsPage = (tagsPageNumber) => {
    this.setState({ tagsPageNumber }, () => this.sendGetTagsRequest());
  };

  handleSearchTag = (tagsSearchValue) => {
    this.setState({ tagsSearchValue, tagsPageNumber: 0 }, () => this.sendGetTagsRequest());
  };

  handleSortTag = (tagsSortBy, tagsSortDirection) => {
    this.setState({ tagsSortBy, tagsSortDirection, tagsPageNumber: 0 }, () => this.sendGetTagsRequest());
  };

  handleSearchTagKeyPress = (event, value) => {
    if (event.key === 'Enter') {
      this.handleSearchTag(value);
    }
  };

  selectTag = (tag) => {
    this.sendGetAccessLevelsRequest();
    this.sendGetTagTypesRequest();
    this.resetTagFormFields();
    let tagId = tag.tagId ? tag.tagId : null,
      tagUid = tag.tagUid ? tag.tagUid : '',
      status = tag.status || tag.status === 0 ? tag.status : 1,
      tagPin = tag.tagPin ? tag.tagPin : '',
      tagTypeId = tag.tagTypeId ? tag.tagTypeId : '',
      accessLeft = tag.accessLeft >= 0 ? tag.accessLeft : '',
      minTime = tag.minTime ? displayAbsoluteTime(tag.minTime) : new Date().toJSON(),
      maxTime = tag.maxTime ? displayAbsoluteTime(tag.maxTime) : null,
      accesslevels = tag.accesslevels ? tag.accesslevels : '',
      checkedAccessLevels = tag.accesslevels ? tag.accesslevels : [],
      activateDelay = tag.activateDelay ? tag.activateDelay : null,
      requirePinCode = tag.requirePinCode ? tag.requirePinCode : null,
      mobileId = tag.mobileId,
      useHID = !!tag.mobileId;
    this.setState(
      {
        isEditTagModalOpen: true,
        isNewTag: false,
        tagId,
        tagUid,
        status,
        tagPin,
        tagTypeId,
        accessLeft,
        minTime,
        maxTime,
        accesslevels,
        checkedAccessLevels,
        activateDelay,
        requirePinCode,
        mobileId,
        useHID,
      },
      () => this.getAccessLevelControllerDuplicates(),
    );
  };

  sendGetTagTypesRequest = () => {
    const pageParams = {
      items: -1,
      page: 0,
      value: null,
      sort: 'ASC',
    };
    this.props.getTagTypes(this.props.customerId, pageParams);
  };

  resetTagFormFields = () => {
    this.setState({
      tagId: null,
      tagUid: '',
      status: 1,
      tagPin: '',
      tagTypeId: '',
      accessLeft: '',
      minTime: new Date().toJSON(),
      maxTime: null,
      accesslevels: [],
      checkedAccessLevels: [],
      mobileId: false,
    });
  };

  handleAddTag = () => {
    this.sendGetAccessLevelsRequest();
    this.resetTagFormFields();
    this.setState({ tagsSearchValue: null, isNewTag: true, isEditTagModalOpen: true });
    this.sendGetTagTypesRequest();
  };

  handleSaveTag = () => {
    const {
      tagId,
      tagUid,
      status,
      tagPin,
      tagTypeId,
      accessLeft,
      minTime,
      maxTime,
      accesslevels,
      activateDelay,
      requirePinCode,
      mobileId,
      isHIDSupported,
      useHID,
      isNewTag,
    } = this.state;
    const tagInfos = {
      tagUid: isNewTag && isHIDSupported && useHID ? 'HIDIntegrationUid' : tagUid,
      status,
      tagTypeId,
      accesslevels,
      minTime: hackToAddOffset(minTime),
      maxTime: hackToAddOffset(maxTime),
      accessLeft: accessLeft ? accessLeft : -100,
      tagPin,
      personId: this.state.personId,
      customerId: this.props.customerId,
      ...(activateDelay && { activateDelay }),
      ...(requirePinCode && { requirePinCode }),
      mobileId,
    };
    const editTagInfos = { ...tagInfos, tagId };
    const pageParams = {
      items: this.state.tagsItemsPerPage,
      page: this.state.tagsPageNumber,
      value: this.state.tagsSearchValue,
      sort: 'ASC',
    };
    if (this.state.isNewTag) {
      if (isTagValid(tagUid) || (isHIDSupported && useHID)) {
        this.props.createTag(tagInfos, this.state.personId, this.props.customerId, pageParams, useHID);
      } else {
        // if the tagUid is not valid, open a confirmation dialog
        this.setState({
          isAlertDialogOpen: true,
          alertTitle: i18n.t('alert.createTagTitle'),
          alertContentText: i18n.t('alert.createTagContent', { tagUid }),
          alertConfirmButtonString: 'Global_create',
          alertConfirmAction: () => {
            this.props.createTag(tagInfos, this.state.personId, this.props.customerId, pageParams, false);
            this.setState({ isAlertDialogOpen: false });
          },
        });
      }
    } else {
      this.props.editTag(tagId, editTagInfos, this.state.personId, this.props.customerId, pageParams);
    }
    this.setState({ isNewTag: false, isEditTagModalOpen: false });
    this.resetTagFormFields();
  };

  openDeleteTagAlert = (tag) => {
    const { tagUid, tagId } = tag;
    const { firstName, lastName } = this.state;
    this.setState({
      tagUid,
      firstName,
      lastName,
      isAlertDialogOpen: true,
      alertTitle: i18n.t('alert.deleteTagTitle'),
      alertContentText: i18n.t('personManager_confirmRemoveTag', { tagUid, firstName, lastName }),
      alertConfirmButtonString: 'Global_delete',
      alertConfirmAction: () => this.deleteTag(tagId),
    });
  };

  deleteTag = (tagId) => {
    const pageParams = {
      items: this.state.tagsItemsPerPage,
      page: this.state.tagsPageNumber,
      value: this.state.tagsSearchValue,
      sort: 'ASC',
    };
    this.props.deleteTag(tagId, this.state.personId, this.props.customerId, pageParams);
    this.setState({ isAlertDialogOpen: false });
  };

  //Access Levels methods

  sendGetAccessLevelsRequest() {
    const pageParams = {
      items: this.state.accesslevelsItemsPerPage,
      page: this.state.accesslevelsPageNumber,
      value: this.state.accesslevelsSearchValue,
      sort: 'ASC',
    };
    this.props.getAccessLevels(this.props.customerId, pageParams);
  }

  changeAccessLevelsItemsPerPage = (accesslevelsItemsPerPage) => {
    this.setState({ accesslevelsItemsPerPage, accesslevelsPageNumber: 0 }, () => this.sendGetAccessLevelsRequest());
  };

  changeAccessLevelsPage = (accesslevelsPageNumber) => {
    this.setState({ accesslevelsPageNumber }, () => this.sendGetAccessLevelsRequest());
  };

  handleSearchAccessLevel = (accesslevelsSearchValue) => {
    this.setState({ accesslevelsSearchValue, accesslevelsPageNumber: 0 }, () => this.sendGetAccessLevelsRequest());
  };

  handleSearchAccessLevelKeyPress = (event, value) => {
    if (event.key === 'Enter') {
      this.handleSearchAccessLevel(value);
    }
  };

  selectAccessLevel = (accessLevel) => {
    const previousAccessLevels = this.state.checkedAccessLevels;
    //check if the accessLevel was present in checkedAccessLevels
    const selectedIndex = previousAccessLevels.findIndex((item) => item.accessLevelId === accessLevel.accessLevelId);
    let newCheckedAccessLevels = [];

    if (selectedIndex === -1) {
      // if not found, add it
      newCheckedAccessLevels = newCheckedAccessLevels.concat(previousAccessLevels, accessLevel);
    } else if (selectedIndex === 0) {
      // if first item, remove it
      newCheckedAccessLevels = newCheckedAccessLevels.concat(previousAccessLevels.slice(1));
    } else if (selectedIndex === previousAccessLevels.length - 1) {
      // if last item, remove it
      newCheckedAccessLevels = newCheckedAccessLevels.concat(previousAccessLevels.slice(0, -1));
    } else if (selectedIndex > 0) {
      // if between first and last, remove it
      newCheckedAccessLevels = newCheckedAccessLevels.concat(
        previousAccessLevels.slice(0, selectedIndex),
        previousAccessLevels.slice(selectedIndex + 1),
      );
    }
    this.setState({ checkedAccessLevels: newCheckedAccessLevels });
  };

  closeAccessLevelsWithoutSave = () => {
    this.setState((prevState) => ({
      checkedAccessLevels: prevState.accesslevels,
      isAccessLevelsModalOpen: false,
    }));
  };

  getAccessLevelControllerDuplicates = () => {
    let accessLevelIds = [];
    this.state.accesslevels.forEach((accesslevel) => {
      accessLevelIds.push(accesslevel.accessLevelId);
    });
    this.props.getMultipleAccessLevelControllers(accessLevelIds);
  };

  saveAccessLevels = () => {
    this.setState(
      (prevState) => ({
        accesslevels: prevState.checkedAccessLevels,
        isAccessLevelsModalOpen: false,
      }),
      () => this.getAccessLevelControllerDuplicates(),
    );
  };

  removeAccessLevel = (accessLevel) => {
    const previousAccessLevels = this.state.accesslevels;
    const selectedIndex = previousAccessLevels.findIndex((item) => item.accessLevelId === accessLevel.accessLevelId);
    const accesslevels = [
      ...previousAccessLevels.slice(0, selectedIndex),
      ...previousAccessLevels.slice(selectedIndex + 1),
    ];
    this.setState({ accesslevels, checkedAccessLevels: accesslevels }, () => this.getAccessLevelControllerDuplicates());
  };

  handleSelectTagType = (tagTypeId) => {
    const selectedTagTypeData = this.props.tagTypes.find((tagType) => tagType.tagTypeId === tagTypeId);
    const {
      defaultActivateDelay,
      defaultCounterValue,
      defaultFutureTimeValue,
      defaultRequirePinCode,
    } = selectedTagTypeData;
    const maxTime = defaultFutureTimeValue >= 0 ? addHours(new Date(), defaultFutureTimeValue).toJSON() : null;
    this.setState({
      tagTypeId,
      accessLeft: defaultCounterValue >= 0 ? defaultCounterValue : '',
      activateDelay: defaultActivateDelay,
      requirePinCode: defaultRequirePinCode,
      maxTime,
    });
  };

  // HID support
  checkHID = () => {
    const { customers, customerIdSub } = this.props;
    const isHIDSupported = checkPermission(customers, customerIdSub, availableSettings.hid);
    this.setState({ isHIDSupported });
  };

  render() {
    const { t, classes, width } = this.props;
    const isLarge = width === 'lg' || width === 'xl';
    const personsData = cloneDeep(this.props.persons); //this is necessary for table to work
    const flattenedPersonsData = personsData
      ? personsData.map((person) => ({
          ...person,
          firstName: convertUnicode(person.address.firstName),
          lastName: convertUnicode(person.address.lastName),
          personCompanyInfo: convertUnicode(person.personCompanyInfo),
        }))
      : null;
    const tagsData = this.props.tags
      ? cloneDeep(this.props.tags).map((tag) => ({
          ...tag,
          statusDisplay: t(`statusMode.${statusConfig.find((statusItem) => statusItem.id === tag.status).name}`),
          accessLevelNames: tag.accesslevels
            .map((accessLevel) => accessLevel.name)
            .join('<span style="color:#ACACAC;"> | </span>'),
        }))
      : [];

    return (
      <MainContentContainer className={classes.MainContentContainer}>
        <AlertDialog
          open={this.state.isAlertDialogOpen}
          handleClose={() => this.setState({ isAlertDialogOpen: false })}
          title={this.state.alertTitle}
          contentText={this.state.alertContentText}
          cancelButtonText={t('Global_cancel')}
          confirmButtonText={t(this.state.alertConfirmButtonString)}
          onConfirm={this.state.alertConfirmAction}
        />
        <SnackbarNotification
          variant={this.state.snackbarVariant}
          open={this.state.isSnackbarNotificationOpen}
          message={this.state.snackbarMessage}
          close={() => this.setState({ isSnackbarNotificationOpen: false })}
        />
        {/* edit tag modal */}
        <Modal
          open={this.state.isEditTagModalOpen}
          handleClose={() => this.setState({ isEditTagModalOpen: false })}
          Content={TagEditModal}
          onClickSave={this.handleSaveTag}
          title={this.state.isNewTag ? t('persons.newTag') : t('persons.editTag')}
          openAccessLevelsModal={() => this.setState({ isAccessLevelsModalOpen: true })}
          person={`${this.state.firstName} ${this.state.lastName}`}
          tagUid={this.state.tagUid}
          onChange={this.handleChangeFormValues}
          isNewTag={this.state.isNewTag}
          tagId={this.state.tagId}
          status={this.state.status}
          tagPin={this.state.tagPin}
          tagTypeId={this.state.tagTypeId}
          accessLeft={this.state.accessLeft}
          minTime={this.state.minTime}
          maxTime={this.state.maxTime}
          accesslevels={this.state.accesslevels}
          // status select
          statusSelectData={statusConfig.map((stat) => ({ id: stat.id, name: t(`statusMode.${stat.name}`) }))}
          statusSelectLabel={t('persons.status')}
          statusAccessValue={'id'}
          statusAccessLabel={'name'}
          statusSelectValue={this.state.status}
          statusOnSelect={(status) => this.setState({ status })}
          // tagTypes select
          tagTypesSelectData={this.props.tagTypes}
          tagTypesSelectLabel={t('persons.type')}
          tagTypesAccessValue={'tagTypeId'}
          tagTypesAccessLabel={'name'}
          tagTypesSelectValue={this.state.tagTypeId}
          tagTypesOnSelect={(tagTypeId) => this.handleSelectTagType(tagTypeId)}
          // date pickers
          selectedStartDate={this.state.minTime}
          handleStartDateChange={(tagStartDate) => this.setState({ minTime: tagStartDate?.toJSON() })}
          selectedEndDate={this.state.maxTime}
          handleEndDateChange={(tagEndDate) => this.setState({ maxTime: tagEndDate?.toJSON() })}
          // HID, new "Get mobile ID"
          mobileId={this.state.mobileId}
          isHIDSupported={this.state.isHIDSupported}
          useHID={this.state.useHID}
          onChangeUseHID={(event) => {
            this.setState({ useHID: event.target.checked });
          }}
          showHIDEmailValidationError={this.state.showHIDEmailValidationError}
          // access levels table list in edit tag modal
          data={cloneDeep(this.state.accesslevels)}
          columns={[{ title: t('personManager_AddTagsModal_AccessLevels_col1'), field: 'name', id: 'name' }]}
          deleteColumn
          noDataText={t('accessLevels.noAccessLevel')}
          handleDeleteButtonClick={(accessLevel) => this.removeAccessLevel(accessLevel)}
          noHeader
          noFooter
          // common
          lightTheme
          formStyle
          selectWidth={225}
          accessLevelsHasDuplicates={this.props.accessLevelsHasDuplicates}
          accessLevelsHasDuplicatesisLoading={this.props.accessLevelsHasDuplicatesisLoading}
        />
        {/* add access levels modal */}
        <Modal
          open={this.state.isAccessLevelsModalOpen}
          handleClose={this.closeAccessLevelsWithoutSave}
          Content={AccessLevelsModal}
          onClickSave={this.saveAccessLevels}
          // search access levels table props
          checkboxColumn="start"
          data={cloneDeep(this.props.accesslevels)}
          noDataText={t('accessLevels.noAccessLevel')}
          handleClick={(accessLevel) => this.selectAccessLevel(accessLevel)}
          columns={[{ title: t('common.name'), field: 'name', id: 'name' }]}
          handleSearch={this.handleSearchAccessLevel}
          activeRowField={'accessLevelId'}
          checkedArray={this.state.checkedAccessLevels}
          searchPlaceholder={t('accessLevels.searchAccessLevel')}
          itemsPerPage={this.state.accesslevelsItemsPerPage}
          changeItemsPerPage={this.changeAccessLevelsItemsPerPage}
          totalElements={this.props.accesslevelsTotalElements}
          page={this.state.accesslevelsPageNumber}
          changePage={this.changeAccessLevelsPage}
          onKeyPress={this.handleSearchAccessLevelKeyPress}
          // rows per page select props
          selectData={[5, 10, 20]}
          selectLabel={t('table.showPerPage')}
          selectValue={this.state.accesslevelsItemsPerPage}
          onSelect={this.changeAccessLevelsItemsPerPage}
          selectWidth={90}
        />
        <Header />
        <Grid container className={classes.gridContainer} spacing={isLarge ? 6 : 5}>
          <Grid item xs={12} md={6} xl={5}>
            <Paper className={clsx(classes.paper, classes.listWidget)}>
              <Table
                data={flattenedPersonsData}
                noDataText={t('persons.noPersons')}
                handleClick={(selectedPerson) => this.selectPerson(selectedPerson)}
                columns={[
                  { title: t('personManager_lastName'), field: 'lastName', id: 'lastName' },
                  { title: t('personManager_firstName'), field: 'firstName', id: 'firstName' },
                ]}
                activeRowValue={this.state.personId}
                activeRowField={'personId'}
                handleSearch={this.handleSearchPerson}
                sortBy={this.state.personsSortBy}
                sortDirection={this.state.personsSortDirection}
                handleSort={this.handleSortPerson}
                searchPlaceholder={t('persons.searchPersonOrTag')}
                itemsPerPage={this.state.personsItemsPerPage}
                changeItemsPerPage={this.changePersonsItemsPerPage}
                totalElements={this.props.personsTotalElements}
                page={this.state.personsPageNumber}
                changePage={this.changePersonsPage}
                onKeyPress={this.handleSearchPersonKeyPress}
                // rows per page select props
                selectData={[5, 10, 20]}
                selectLabel={t('table.showPerPage')}
                selectValue={this.state.personsItemsPerPage}
                onSelect={this.changePersonsItemsPerPage}
                selectWidth={90}
              />
            </Paper>
          </Grid>
          <Grid item xs={12} md={6} xl={7}>
            <Paper className={clsx(classes.paper, classes.detailsWidget)}>
              <PersonDetails
                // buttons
                add1ButtonText={t('persons.addPerson')}
                add2ButtonText={t('persons.newTag')}
                onDeleteButtonClick={this.openDeletePersonAlert}
                onAdd1ButtonClick={this.handleAddPerson}
                onAdd2ButtonClick={this.handleAddTag}
                onSaveButtonClick={this.handleSavePerson}
                isDeleteButtonDisabled={!this.state.personId || this.state.isNewPerson}
                add2ButtonDisabled={this.state.isNewPerson}
                saveButtonDisabled={!this.state.personId && !this.state.isNewPerson}
                // person details form
                onKeyPressFormSubmit={this.handlePersonDetailsFormKeyPress}
                onChange={this.handleChangeFormValues}
                hideDetails={this.state.hideDetails}
                personId={this.state.personId}
                firstName={this.state.firstName}
                lastName={this.state.lastName}
                readOnly={this.state.readOnly}
                personNumber={this.state.personNumber}
                company={this.state.company}
                phone={this.state.phone}
                email={this.state.email}
                emailDisabled={this.state.externalId !== '' || this.state.hasHIDTag}
                // form and validations
                isUntouched={this.state.isUntouched}
                setUntouched={(value) => this.setState({ isUntouched: value })}
                // tags table
                tableTitle={t('persons.tags')}
                data={tagsData}
                columns={[
                  { title: t('persons.tag'), field: 'tagUid' },
                  { title: '', field: 'mobileId', type: 'mobileId' },
                  { title: t('persons.status'), field: 'statusDisplay' },
                  { title: t('personManager_tags_col2'), field: 'accessLevelNames', type: 'specialHTML' },
                ]}
                activeRowValue={this.state.tagUid}
                activeRowField={'tagUid'}
                // show per page
                itemsPerPage={this.state.tagsItemsPerPage}
                changeItemsPerPage={this.changeTagsItemsPerPage}
                // search
                searchPlaceholder={t('persons.searchTag')}
                handleSearch={this.handleSearchTag}
                searchDisabled={!this.state.personId}
                sortBy={this.state.tagsSortBy}
                sortDirection={this.state.tagsSortDirection}
                handleSort={this.handleSortTag}
                noSort={['accessLevelNames']}
                onKeyPress={this.handleSearchTagKeyPress}
                noDataText={t('persons.noTags')}
                handleClick={(tag) => this.selectTag(tag)}
                deleteColumn
                handleDeleteButtonClick={(tag) => this.openDeleteTagAlert(tag)}
                totalElements={this.props.tagsTotalElements}
                page={this.state.tagsPageNumber}
                changePage={this.changeTagsPage}
                // rows per page select props
                selectData={[5, 10, 20]}
                selectLabel={t('table.showPerPage')}
                selectValue={this.state.tagsItemsPerPage}
                onSelect={this.changeTagsItemsPerPage}
                selectWidth={90}
              />
            </Paper>
          </Grid>
        </Grid>
      </MainContentContainer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    customerId: state.auth.customerId,
    customerIdSub: state.auth.customerIdSub,
    customers: state.customers.customers,
    customerProfile: state.auth.customerProfile,
    //persons
    persons: state.persons.persons,
    personsTotalElements: state.persons.totalElements,
    createdId: state.persons.createdId,
    createdAddressId: state.persons.createdAddressId,
    savedEmail: state.persons.savedEmail,
    personsIsLoading: state.persons.isLoading,
    personsSuccessMessage: state.persons.successMessage,
    personsErrorMessage: state.persons.errorMessage,
    //tags
    tags: state.tags.personTags,
    tagsTotalElements: state.tags.totalElements,
    tagsIsLoading: state.tags.isLoading,
    tagsSuccessMessage: state.tags.successMessage,
    tagsErrorMessage: state.tags.errorMessage,
    tagTypes: state.tagTypes.tagTypes,
    //access levels
    accesslevels: state.accessLevels.accessLevels,
    accesslevelsTotalElements: state.accessLevels.totalElements,
    accessLevelsHasDuplicates: state.accessLevels.accessLevelsHasDuplicates,
    accessLevelsHasDuplicatesisLoading: state.accessLevels.accessLevelsHasDuplicatesisLoading,
  };
};

const mapDispatchToProps = (dispatch) => ({
  //persons
  getPersons: (customerId, pageParams) => dispatch(PersonsActions.getPersonsRequest(customerId, pageParams)),
  createPerson: (personInfos, customerId, pageParams) =>
    dispatch(PersonsActions.createPersonRequest(personInfos, customerId, pageParams)),
  editPerson: (personInfos) => dispatch(PersonsActions.editPersonRequest(personInfos)),
  deletePerson: (personId, customerId, pageParams) =>
    dispatch(PersonsActions.deletePersonRequest(personId, customerId, pageParams)),
  resetPersons: () => dispatch(PersonsActions.resetPersons()),
  //tags
  getTags: (personId, customerId, pageParams) =>
    dispatch(TagsActions.getPersonTagsRequest(personId, customerId, pageParams)),
  createTag: (tagInfos, personId, customerId, pageParams, useHID) =>
    dispatch(TagsActions.createPersonTagRequest(tagInfos, personId, customerId, pageParams, useHID)),
  editTag: (tagId, tagInfos, personId, customerId, pageParams) =>
    dispatch(TagsActions.editPersonTagRequest(tagId, tagInfos, personId, customerId, pageParams)),
  deleteTag: (tagId, personId, customerId, pageParams) =>
    dispatch(TagsActions.deletePersonTagRequest(tagId, personId, customerId, pageParams)),
  resetTags: () => dispatch(TagsActions.resetTags()),
  // tag types
  getTagTypes: (customerId, pageParams) => dispatch(TagTypesActions.getTagTypesRequest(customerId, pageParams)),
  resetTagTypes: () => dispatch(TagTypesActions.resetTagTypes()),
  //access levels
  getAccessLevels: (customerId, pageParams) =>
    dispatch(AccessLevelsActions.getAccessLevelsRequest(customerId, pageParams)),
  getMultipleAccessLevelControllers: (accessLevelIds) =>
    dispatch(AccessLevelsActions.getMultipleAccessLevelControllersRequest(accessLevelIds)),
  resetAccessLevels: () => dispatch(AccessLevelsActions.resetAccessLevels()),
});

export default compose(
  withTranslation(),
  withStyles(styles),
  withWidth(),
  connect(mapStateToProps, mapDispatchToProps),
)(Persons);
